module.exports = __webpack_public_path__ + "img/simplysift.b82043f9.png";